module.exports = __webpack_public_path__ + "img/Phone_06.4d3a49c5.jpg";